/* 
 * @Author: 曹俊杰 
 * @Date: 2022-04-13 17:14:56
 * @Module:企业实名认证 
 */
 <template>
  <div>
    <el-card shadow="never">
      <hdqSection title="加入/创建企业" more-text="" />
      <div class="content">
        <el-form ref="form" label-position="right" :model="form" label-width="200px" :rules="rules" size="small">
          <el-form-item label="公司名" prop="name">
            <el-input v-model="form.name" placeholder="请输入您的公司名"></el-input>
          </el-form-item>
          <el-form-item label="统一社会信用代码" prop="idNumber">
            <el-input v-model="form.idNumber" placeholder="请输入您的统一社会信用代码"></el-input>
          </el-form-item>
          <el-form-item label="法人代表姓名" prop="representativeName">
            <el-input v-model="form.representativeName" placeholder="请输入您的法人代表姓名"></el-input>
          </el-form-item>
          <el-form-item label="法人代表证件号" prop="representativeIdNumber">
            <el-input v-model="form.representativeIdNumber" placeholder="请输入您的法人代表证件号"></el-input>
          </el-form-item>
          <el-form-item label="法人代表手机号" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入法人代表手机号"></el-input>
          </el-form-item>
        </el-form>
        <div style="height:20px;"></div>
        <el-button type="primary" style="width:100%;" @click="submitForm" :loading="loading">确 定</el-button>
      </div>
    </el-card>
    <qrDialog ref="qrDialog">
      <span class="text">
        <span>请企业法人用</span>
        <span>支付宝APP</span>
        <span>扫码并按照提示完成认证</span>
      </span>
    </qrDialog>
  </div>
</template>
 <script>
import qrDialog from "@/components/qrDialog.vue"
let js
export default {
  components: {
    qrDialog
  },
  data () {
    const phoneValidator = (_, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      }
      if (this.$utils.test.mobile(value)) {
        return callback();
      } else {
        return callback(new Error('请输入正确的手机号'));
      }
    }
    const representativeIdNumber = (_, value, callback) => {
      if (!value) {
        return callback(new Error('法人代表证件号不能为空'));
      }
      if (this.$utils.test.idCard(value)) {
        return callback();
      } else {
        return callback(new Error('请输入正确的法人代表证件号'));
      }
    }
    return {
      loading: false,
      form: {
        name: '',
        idNumber: '',
        representativeName: '',
        representativeIdNumber: '',
        phone: '',
      },
      rules: {
        idNumber: [{ required: true, message: '统一社会信用代码不能为空', trigger: 'blur' }],
        representativeName: [{ required: true, message: '法人代表姓名不能为空', trigger: 'blur' }],
        representativeIdNumber: [{ required: true, validator: representativeIdNumber, trigger: 'blur' }],
        name: [{ required: true, message: '公司名不能为空', trigger: 'blur' }],
        phone: [{ required: true, validator: phoneValidator, trigger: 'blur' }],
      },
      dialogVisible: false,
      authUrl: ''
    };
  },
  mounted () { },
  methods: {
    submitForm () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.postAccountAuth()
        } else {
          return false;
        }
      });
    },
    async postAccountAuth () {
      this.loading = true
      const { status, info, data } = await this.$api.postAccountCompanyAuth(this.form);
      if (status == 200) {
        this.$message({
          type: 'success',
          message: info
        })
        this.$refs.qrDialog.show(data.authUrl)
        js = setInterval(() => {
          this.$api.getCompanyAuthTask({ taskUuid: data.taskUuid }).then(({ data: { success } }) => {
            if (success) {
              this.$refs.qrDialog.hidden()
              clearInterval(js);
              this.$message({
                type: 'success',
                message: '实名认证成功'
              })
              this.$router.go(-1);
              this.$store.dispatch('user/getAccount')
              this.$store.dispatch('user/getCompanyMine')
            }

          })
        }, 1000);
      } else {
        this.$message({
          type: 'error',
          message: info
        })
      }
      this.loading = false
    },
    close () {
      js && clearInterval(js);
    }
  },
};
 </script>
 <style lang='scss' scoped>
.content {
  width: 500px;
  margin: 0 auto;
  padding-top: 20px;
}
</style>